import * as React from 'react';

import Bee from '@beefree.io/sdk';

import {BeeEditor} from '../bee-editor';
import {useGetBeeToken} from '../graphql/hooks/use-get-bee-token';

type Props = {
    onSendEmail?: (toEmailAddresses: string[], html: string) => Promise<any>;
    marketingEmailTemplate: string | null | undefined;
    onSave?: (beeContentJson: string, beeContentHtml: string) => Promise<any>;
    onChange?: (beeContentJson: string, editionId: string) => any;
    getBeeRef?: (bee: Bee) => void;
    isPreview?: boolean;
    testEmailToAddress?: string[];
    editionId: string;
    editionPreviewUrl: string;
    shouldReload?: boolean;
    setShouldReload?: (arg1: boolean) => void;
};

export function BeeEditorEmailBuilder(props: Props) {
    const {beeToken} = useGetBeeToken('email_builder');

    if (!beeToken) return null;

    // @ts-expect-error
    return <BeeEditor {...props} beeToken={beeToken} />;
}
